import RRTphoto from "./imgs/RRT2.jpg";
import ACSphoto from "./imgs/ACS.jpg";
import CSTphoto from "./imgs/CST.jpg";
import JOGphoto from "./imgs/JOG.jpg";
import GVVphoto from "./imgs/GVV.jpg";

export const coFounders = [
  {
    photo: RRTphoto,
    photoAlt: "foto Rodrigo Riquelme",
    name: "Rodrigo A. Riquelme Tapia",
    info: "Con una sólida trayectoria de más de 20 años, Rodrigo ha desarrollado una perspectiva panorámica única de las diversas áreas del negocio minero y sus impactos. Esta amplia experiencia le ha permitido formar parte de equipos multidisciplinarios y especializarse en la estimación de reservas y recursos, el análisis de riesgos y los modelos geológicos y geometalúrgicos para las principales empresas mineras de Chile. Su profundo conocimiento y experiencia han sido fundamentales para el éxito de estos proyectos. ",
  },
  {
    photo: CSTphoto,
    photoAlt: "foto Cynthia San Martín",
    name: "Cynthia San Martín",
    info: "Cynthia es Ingeniera Comercial, con experiencia en áreas de finanzas, gestión y estrategia empresarial. Ha participado en la planificación y control presupuestario, así como en la implementación de herramientas de gestión y control. Cuenta con experiencia liderando equipos y colaborando en procesos clave del negocio. Su interés profesional está orientado a apoyar la toma de decisiones y contribuir al logro de los objetivos organizacionales desde una mirada estratégica.",
  },
  {
    photo: ACSphoto,
    photoAlt: "foto Alejandro Cáceres",
    name: "Alejandro M. Cáceres Saavedra",
    info: "Alejandro destaca por su habilidad para discernir las necesidades del cliente y determinar la mejor aproximación a los distintos proyectos. Con más de diecisiete años de experiencia como consultor independiente, se ha especializado en el análisis de riesgos, conciliaciones, modelamiento, estimación y clasificación de recursos en proyectos para las principales compañías mineras del país. Además, Alejandro se desempeña como profesor de cátedra del curso de Evaluación de Yacimientos en la Universidad de Chile. Su enfoque siempre ha sido la integración técnica y financiera a lo largo de la cadena de valor del negocio minero.",
  },
];

export const teamRow1 = [

  {
    photo: GVVphoto,
    photoAlt: "foto Guiselle Valderrama",
    name: "Guiselle Valderrama V.",
    info: "Ingeniera Geóloga con más de 16 años de experiencia en minería y desarrollo de negocios, Magíster en Modelamiento Geoestadístico en Depósitos Minerales y Persona Competente acreditada por AusIMM. Especialista en modelamiento de depósitos, gestión estratégica y optimización de procesos mineros, con trayectoria en consultoría, liderazgo de equipos y expansión de mercados en Latinoamérica.",
  },
   {
    photo: JOGphoto,
    photoAlt: "foto Javier Ortiz",
    name: "Javier E. Ortiz Guzmán",
    info: "Javier, con más de 5 años de experiencia en GeoInnova, está interesado en el desarrollo de software y ha invertido tiempo y esfuerzo en perfeccionarse en esta área. Su interés se ha centrado en el desarrollo de aplicaciones para la industria minera, tanto en el Frontend como en el Backend. Mientras que su enfoque incluye análisis de datos, cómputo paralelo y simulación de datos, lo que demuestra su habilidad para abordar tareas complejas y exigentes. Javier ha sido parte activa en proyectos que involucran el desarrollo de soluciones tecnológicas innovadoras para la industria minera, demostrando su capacidad para aprovechar las últimas tecnologías y tendencias.  ",
  },
];

export const textArea1 =[{text:" GeoGnoSim es una herramienta computacional que, mediante la utilización de modelos estocásticos,genera múltiplesescenarios de un yacimiento mineral, con información de dominios geológicos tales como litología, alteración, zonas minerales, entre otras. Estos escenarios permiten cuantificar la incertidumbre asociada a la interpretación geológica del yacimiento, facilitando la toma de decisiones robustas a eventuales desviaciones entre el modelo interpretado y la realidad en las diferentes etapas de ciclo de vida de un proyecto minero: exploración temprana, exploración avanzada, explotación, etc."}];

/*export const teamRow2 = [
  {
    photo: JOGphoto,
    photoAlt: "foto Javier Ortiz",
    name: "Javier E. Ortiz Guzmán",
    info: "Quisque sodales,",
  },

];*/
